import React from 'react';
import ReactContentEditable from 'react-contenteditable';

// TODO: ReactContentEditable interface is not available
export interface TextwChipsEditableWrapperProps extends React.ComponentPropsWithoutRef<'input'> {
  tagName: string;
  onChange?(any): any;
  onInput?: React.FormEventHandler;
  onBlur?: React.FocusEventHandler;
  onKeyDown?: React.KeyboardEventHandler;
  onKeyPress?: React.KeyboardEventHandler;
  html: string
}

/**
 * Internal component. Wrapper around react-contenteditable due to that library's lack
 * of compatibility with React hooks.
 */
const TextwChipsEditableWrapper = React.forwardRef<HTMLElement, TextwChipsEditableWrapperProps>((props: TextwChipsEditableWrapperProps, ref) => {
  const {
    onChange,
    onInput,
    onBlur,
    onKeyPress,
    onKeyDown,
    html,
    tagName,
    ...otherProps
  } = props;
  const onChangeRef = React.useRef(onChange);
  const onInputRef = React.useRef(onInput);
  const onBlurRef = React.useRef(onBlur);
  const onKeyPressRef = React.useRef(onKeyPress);
  const onKeyDownRef = React.useRef(onKeyDown);

  React.useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  React.useEffect(() => {
    onInputRef.current = onInput;
  }, [onInput]);
  React.useEffect(() => {
    onBlurRef.current = onBlur;
  }, [onBlur]);
  React.useEffect(() => {
    onKeyPressRef.current = onKeyPress;
  }, [onKeyPress]);
  React.useEffect(() => {
    onKeyDownRef.current = onKeyDown;
  }, [onKeyDown]);

  return (
    <ReactContentEditable
      {...otherProps}
      tagName={tagName}
      html={html}
      innerRef={ref}
      onChange={
          onChange
            ? (...args) => {
              if (onChangeRef.current) {
                onChangeRef.current(...args);
              }
            }
            : undefined
        }
      onInput={
          onInput
            ? (...args) => {
              if (onInputRef.current) {
                onInputRef.current(...args);
              }
            }
            : undefined
        }
      onBlur={
          onBlur
            ? (...args) => {
              if (onBlurRef.current) {
                onBlurRef.current(...args);
              }
            }
            : undefined
        }
      onKeyPress={
          onKeyPress
            ? (...args) => {
              if (onKeyPressRef.current) {
                onKeyPressRef.current(...args);
              }
            }
            : undefined
        }
      onKeyDown={
          onKeyDown
            ? (...args) => {
              if (onKeyDownRef.current) {
                onKeyDownRef.current(...args);
              }
            }
            : undefined
        }
    />
  );
});

TextwChipsEditableWrapper.defaultProps = {
  onChange: undefined,
  onInput: undefined,
  onBlur: undefined,
  onKeyDown: undefined,
  onKeyPress: undefined
};

TextwChipsEditableWrapper.displayName = 'TextwChipsEditableWrapper';
export default TextwChipsEditableWrapper;
